export const ONBOARDING_STORAGE_KEY = 'create-collection-onboarding';
